// ./utils/resolveMediaUrl.js
export const resolveMediaUrl = (pathOrUrl) => {
  if (!pathOrUrl) return null;

  // Already absolute
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;

  // Allow protocol-relative //cdn...
  if (pathOrUrl.startsWith('//')) return pathOrUrl;

  const base = process.env.NEXT_PUBLIC_API_URL || '';
  if (!base) return pathOrUrl; // fallback: leave as-is if not configured

  // Avoid double slashes
  const baseNoSlash = base.endsWith('/') ? base.slice(0, -1) : base;
  const pathWithSlash = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${baseNoSlash}${pathWithSlash}`;
};


